import { create } from 'zustand';

type SpeciesSelection = {
  value: string;
  label: string;
};

interface SpeciesSelectionStore {
  selection: SpeciesSelection | null;
  setSelection: (selection: SpeciesSelection) => void;
  clearSelection: () => void;
}

export const useSpeciesSelectionStore = create<SpeciesSelectionStore>(
  (set) => ({
    selection: null,
    setSelection: (selection): void => set({ selection }),
    clearSelection: (): void => set({ selection: null }),
  }),
);
